<template>
    <div id="quan">
      <div class="quan">
        <div class="info" :style="'background-image:url('+imgPath+'quan/quan-bg.png)'">
          <div class="bolls">
            <div class="boll"></div>
            <div class="boll"></div>
            <div class="boll"></div>
            <div class="boll"></div>
            <div class="boll"></div>
            <div class="boll"></div>
          </div>
          <div class="use"><span v-if="quan.enabled == 'yes'">未使用</span><span v-else>已使用</span></div>
          <div class="head-card">
            <div class="head-img"><img :src="quan.pic_url" alt=""></div>
            <div class="head-right">
              <p>商户名称：{{quan.ds_name}}</p>
              <p>卡号：{{quan.code}}</p>
            </div>
          </div>
          <div class="text">
            <h3>中秋月饼优惠券</h3>
            <p class="tip">（ 总购物金额满200元可用 ）</p>
          </div>
          <ul class="explain">
            <li>
              <span>卡券类型：</span>
              <p v-if="quan.type == 'discount'">折扣券</p>
              <p v-if="quan.type == 'money'">代金券</p>
              <p v-if="quan.type == 'gift'">礼品券</p>
              <p v-if="quan.type == 'coupon'">优惠券</p>
            </li>
            <li>
              <span>销券方式：</span>
              <p>{{quan.ds_name}}</p>
            </li>
            <li>
              <span>有效期：</span>
              <p>{{quan.use_time}} - {{quan.use_time}}</p>
            </li>
            <li>
              <span>使用说明：</span>
              <p>{{quan.ds_name}}</p>
            </li>
          </ul>
        </div>
        <div class="circle">
          <div class="rcircle"></div>
          <div class="wcircle"></div>
        </div>
        <div class="btn">立即使用</div>
        <p class="master">最终解释权归活动举办方所有</p>
        <div class="coupon-box">
          <div class="coupon" :style="'background-image:url('+imgPath+'quan/quan-bg2.jpg)'">
            <div class="line"></div>
            <img :src="imgPath+'quan/2018.png'" alt="2017" class="year">
            <img :src="imgPath+'quan/dog.png'" alt="小狗" class="dog">
            <div class="coupontext">
              <p v-if="quan.type == 'discount'">折扣券</p>
              <p v-if="quan.type == 'money'">代金券</p>
              <p v-if="quan.type == 'gift'">礼品券</p>
              <p v-if="quan.type == 'coupon'">优惠券</p>
              <p>Raffle ticket</p><p>●●●●</p></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
    //保存数据

    export default {
        data() {
            return {
              fansId:"",
              quanId:0,
              quan:'',
              imgPath:''
            }
        },
        created() {
          this.imgPath = tool.imgPath();
         var current_app_Id = window.localStorage.getItem("current_app_Id");
         var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
         this.fans_id = fans.fans_id;
          this.quanId = this.$route.params.id;
          console.log(this.quanId);
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData(){
              var that = this;
              var option = 'id='+this.quanId;
              this.axios.post(tool.baseUrl()+'/coupon/index/info',option).then(function(data){
                if(data.data.code == "200") {
                  that.quan = data.data.data.list[0];
                }else{
                  console.log(data.data.message)
                }
              }).catch(function(){
                  console.log(data.data.message)
              })
            }
        }
    }
</script>

<style scoped>
img {
  max-width: 100%;
  vertical-align: middle;
}

#quan {
  height: 100%;
  background: #f4f4f4;
  padding: 15px;
  box-sizing: border-box;
  color: #fff;
}

.quan {
  box-shadow: 4px 4px 16px -5px #e2a5a5;
  background: #fff;
  position: relative;
  padding-bottom: 30px;
}

.info {
  position: relative;
  overflow: hidden;
  background-color: #f44343;
  background-repeat: repeat;
  -webkit-background-size: 13px;
  background-size: 13px;
  padding: 30px 20px 50px;
}

.bolls {
  position: absolute;
  top: -20px;
  left: 0;
}

.boll {
  height: 30px;
  width: 30px;
  background: #f4f4f4;
  border-radius: 50%;
  margin-left: 10px;
  display: inline-block;
}

.use {
  position: absolute;
  top: 0;
  width: 70px;
  height: 28px;
  line-height: 28px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  background: #ffd34c;
  color: #f44343;
  right: 10px;
  text-align: center;
  box-shadow: 0 0 10px #d41e1e;
}

.head-card {
  display: flex;
}

.head-img {
  width: 82px;
  height: 82px;
  border-radius: 50%;
  overflow-y: hidden;
  text-align: center;
  box-shadow: 4px 4px 10px #c41f1f;
  background: #fff;
}

.head-img img {
  width: 80%;
  margin-top: 14px
}

.head-right {
  padding-top: 20px;
  padding-left: 10px;
  line-height: 25px;
}

.text {
  text-align: center;
  margin-top: 20px;
}

.text h3 {
  font-size: 16px;
  position: relative;
}

.text h3:after,.text h3:before {
  position: absolute;
  content: '';
  width: 82px;
  top: 12px;
  border-top: 2px dashed #fff;
}

.text h3:after {
  left: 0;
}

.text h3:before {
  right: 0;
}

.text p {
  color: #fff9af;
  margin-top: 10px;
}

.explain li {
  line-height: 25px;
}

.explain li span {
  width: 5em;
  text-align: right;
  float: left;
}

.explain li p {
  padding-left: 5em;
}

.circle {
  height: 40px;
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: -40px;
}

.rcircle {
  position: absolute;
  top: 0;
  width: 1000px;
  height: 1000px;
  background: #ea3434;
  border-radius: 50%;
  left: 50%;
  margin-left: -500px;
}

.wcircle {
  position: absolute;
  top: 0;
  width: 1200px;
  height: 1200px;
  background: #fff;
  border-radius: 50%;
  left: 50%;
  margin-left: -600px;
  top: 10px;
}

.btn {
  position: relative;
  height: 36px;
  width: 60%;
  line-height: 36px;
  border-radius: 18px;
  background: #fd3f3f;
  text-align: center;
  margin: 0 auto;
}

.btn:before {
  content: '';
  position: absolute;
  height: 3px;
  width: 18px;
  right: 30px;
  top: 5px;
  background: #fff;
  border-radius: 3px;
}

.btn:after {
  content: '';
  position: absolute;
  height: 3px;
  width: 3px;
  right: 20px;
  top: 5px;
  background: #fff;
  border-radius: 3px;
}

.master {
  color: #949494;
  line-height: 36px;
  text-align: center;
}

.coupon-box {
  margin: 10px 20px;
  box-shadow: 3px 3px 20px #ffd0d0;
  padding: 9px;
}

.coupon {
  background-repeat: repeat;
  border-radius: 3px;
  -webkit-background-size: 32px;
  background-size: 32px;
  height: 84px;
  overflow: hidden;
  position: relative;
}

.line {
  position: absolute;
  left: 30%;
  top: 15px;
  height: 56px;
  width: 0;
  border-left: 2px dashed #fff;
}

.line:before,.line:after {
  content: '';
  position: absolute;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background: #fff;
  left: -16px;
}

.line:before {
  top: -40px;
}

.line:after {
  bottom: -40px;
}

.year {
  position: absolute;
  top: 16px;
  left: 40%;
  width: 105px;
}

.dog {
  position: absolute;
  top: 36px;
  left: 50%;
  width: 48px;
}

.coupontext {
  position: absolute;
  top: 16px;
  right: 5%;
  color: #fff79a;
  line-height: 12px;
  font-size: 12px
}

.coupontext p:nth-child(2) {
  font-size: 8px;
  line-height: 8px;
}
</style>


// WEBPACK FOOTER //
// quan.vue?7ceef1cb